// src/types/User.ts
import { Session } from '../../types/session/session';
import httpClient from '../httpClient/httpClient';
export interface User {
  userId: number;
  email: string;
  // Add more fields as needed
}

const routePrefix: string = "/identity";


export const SessionService = {
  async getSession(): Promise<Session> {
    const res = await httpClient.get<Session>(`${routePrefix}/getSession`);
    return res.data;
  },
};
